import { render, staticRenderFns } from "./Inquiry.vue?vue&type=template&id=fdf493a6&scoped=true&"
import script from "./Inquiry.vue?vue&type=script&lang=js&"
export * from "./Inquiry.vue?vue&type=script&lang=js&"
import style0 from "./Inquiry.vue?vue&type=style&index=0&id=fdf493a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf493a6",
  null
  
)

export default component.exports